import React, { useState, useRef, useEffect } from "react";

import { CustomInputInterface } from "../../interfaces";
import { eyeSvg, eyeCloseSvg } from "../../svgs";
import {
  CustomInputWrapper,
  Input,
  InputLabel,
  ShowPasswordText,
} from "./styled";

const CustomInput: React.FC<CustomInputInterface> = (props) => {
  const {
    inputType,
    reactHookOptions,
    errors,
    id,
    inputName,
    defaultValue,
    value,
    margin,
    handleChange,
    className,
    disabled,
    errorMessages,
  } = props;

  const [focused, setFocus] = useState(false);
  const [revealPw, handlePwReveal] = useState(false);
  const [autofiled, setAuto] = useState(!!value || !!defaultValue);

  const inputRef = useRef<HTMLInputElement>();
  // inputRef.current?.querySelector('input')
  const handleClick = () => inputRef.current?.querySelector("input").focus();

  const getAutofilled = () => {
    const input = document.querySelectorAll("input:-webkit-autofill");

    input.forEach((el) => {
      if (el === inputRef.current?.querySelector("input")) {
        setAuto(true);
        // remove transition
        const label = el.closest("div").querySelector("label");
        label.style.transition = "none";
      }
    });
  };

  useEffect(() => {
    setAuto(focused);
    const timer = setTimeout(getAutofilled, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [focused]);

  return (
    <CustomInputWrapper
      ref={inputRef}
      style={{ margin }}
      className={`${focused ? " -focused" : ""} ${
        errors ? " -error" : ""
      } ${className}`}
    >
      <InputLabel
        htmlFor={id}
        className={`${
          autofiled || inputRef.current?.querySelector("input").value.length > 0
            ? " -focused"
            : ""
        }
         ${focused ? "focus" : ""}`}
        onClick={handleClick}
      >
        {inputName}
      </InputLabel>
      {inputType === "password" && (
        <ShowPasswordText
          onClick={() => handlePwReveal((prevState) => !prevState)}
        >
          {" "}
          {revealPw ? <div>{eyeCloseSvg()} </div> : eyeSvg()}
        </ShowPasswordText>
      )}
      <Input
        autocomplete="__away"
        password={inputType === "password"}
        // eslint-disable-next-line no-nested-ternary
        type={
          inputType !== "password" ? inputType : revealPw ? "text" : "password"
        }
        {...reactHookOptions}
        disabled={disabled}
        id={id}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        value={value}
        placeholder=" "
        className={`${inputType === "password" ? "password-input" : ""}`}
        onChange={(e) => {
          if (reactHookOptions) reactHookOptions.onChange(e);
          if (handleChange) handleChange(e);
        }}
        defaultValue={defaultValue || ""}
        onKeyPress={(e) => {
          if (
            inputType === "number" &&
            (e.key === "e" || e.key === "E" || e.key === "," || e.key === ".")
          ) {
            e.preventDefault();
          }
        }}
      />
      {errorMessages}
    </CustomInputWrapper>
  );
};

export default CustomInput;
